import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { IIcon } from '../../../shared/components/icon/icon.interface';
import { IconSizesEnum } from '../../../shared/components/icon/icons-sizes.enum';
import {
  ITrackingAction,
  TrackingScreenNamesEnum,
} from '../../../tracking/tracking.data';
import { I2gNgTrackingActionBuilder } from 'i2g-ng-tracking';
import { PromoBanner } from '../../../home-data/models';
import { IRouter } from '../../../shared/interfaces/router.interface';

@Component({
  selector: 'app-in-app-promo',
  templateUrl: './in-app-promo.component.html',
  styleUrls: ['./in-app-promo.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InAppPromoComponent implements OnInit, OnChanges {
  @Input() promoBanner: PromoBanner;
  @Input() trackingScreenName: TrackingScreenNamesEnum;

  @Output() onCta1: EventEmitter<void> = new EventEmitter<void>();
  @Output() onCta2: EventEmitter<void> = new EventEmitter<void>();
  @Output() onDismiss: EventEmitter<void> = new EventEmitter<void>();

  icon: IIcon;
  cta1: IRouter;
  cta2: IRouter;
  closeIcon: IIcon;
  cta1Action: ITrackingAction;
  cta2Action: ITrackingAction;
  dismissAction: ITrackingAction;

  constructor(private _trackingActionBuilder: I2gNgTrackingActionBuilder) {}

  ngOnInit() {
    this.closeIcon = {
      name: 'close-navigation',
      size: IconSizesEnum.small,
    };
    this.cta1Action = this._trackingActionBuilder.buildButtonTapped(
      'cta1',
      this.trackingScreenName
    );
    this.cta2Action = this._trackingActionBuilder.buildButtonTapped(
      'cta2',
      this.trackingScreenName
    );
    this.dismissAction = this._trackingActionBuilder.buildButtonTapped(
      'dismiss',
      this.trackingScreenName
    );
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.promoBanner) {
      const icon = this.promoBanner.icon;
      const cta1 = this.promoBanner.cta1;
      const cta2 = this.promoBanner.cta2;

      this.icon = (icon && (icon.toJS() as IIcon)) || null;
      this.cta1 = (cta1 && (cta1.toJS() as IRouter)) || null;
      this.cta2 = (cta2 && (cta2.toJS() as IRouter)) || null;
    }
  }
}
